import { Component, computed, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth';
import { PlayerCard as PlayerCardComponent, PlayerCardData } from '../../components/player-card/player-card';

interface BinderPlayer {
  first: string;
  last: string;
  pos: string;
  team: string;
  cost: number;
  photo: string | null;
}

interface BinderEntry {
  leagueId: number;
  leagueName: string;
  teamName: string;
  year: number;
  rosterSize: number;
  totalSpent: number;
  slotsUsed: number;
  players: BinderPlayer[];
}

interface ProfileData {
  stats: { leagues: number; drafted: number; memberSince: number };
  binder: BinderEntry[];
}

@Component({
  selector: 'app-profile',
  imports: [CommonModule, RouterModule, PlayerCardComponent],
  templateUrl: './profile.html',
  styleUrl: './profile.css',
})
export class Profile implements OnInit {
  user = computed(() => this.authService.currentUser());
  profileData = signal<ProfileData | null>(null);
  isLoading = signal(true);

  readonly tones = [
    'oklch(62% 0.12 145)',
    'oklch(62% 0.14 305)',
    'oklch(66% 0.13 40)',
    'oklch(58% 0.13 250)',
    'oklch(68% 0.12 85)',
  ];

  constructor(private authService: AuthService) {}

  async ngOnInit() {
    try {
      const res = await fetch('/api/profile', { credentials: 'include' });
      if (res.ok) {
        this.profileData.set(await res.json());
      }
    } finally {
      this.isLoading.set(false);
    }
  }

  getInitials(name: string): string {
    return name.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
  }

  tone(i: number): string {
    return this.tones[i % this.tones.length];
  }

  currentBinder(): BinderEntry | null {
    return this.profileData()?.binder[0] ?? null;
  }

  archiveBinder(): BinderEntry[] {
    return this.profileData()?.binder.slice(1) ?? [];
  }

  toCardData(p: BinderPlayer): PlayerCardData {
    return { firstName: p.first, lastName: p.last, position: p.pos, team: p.team, photo: p.photo, cost: p.cost };
  }

  async logout() {
    await this.authService.logout();
  }
}
